module.exports = __webpack_public_path__ + "static/img/GB@3x.02a91a4f.jpg";